import { CalculateNearestChildValues } from "./calculateNearestChildValues";

export interface BCSOShares {
  totalBCSO: number;
  custodialShare: number;
  nonCustodialShare: number;
}

export const calculateBCSOShares = (
  custodialAdjustedIncome: number,
  nonCustodialAdjustedIncome: number,
  numberOfChildren: number,
  worksheetCreatedDate?: string
): BCSOShares => {
  // Calculate combined adjusted income
  const combinedAdjustedIncome = custodialAdjustedIncome + nonCustodialAdjustedIncome;
  
  // Get BCSO from table using existing utility (use max of 0 for table lookup)
  const totalBCSO = CalculateNearestChildValues(
    Math.max(0, combinedAdjustedIncome),
    numberOfChildren,
    worksheetCreatedDate || new Date().toISOString()
  );
  
  // Calculate proportional shares even with negative incomes
  let custodialShare = 0;
  let nonCustodialShare = 0;
  
  if (combinedAdjustedIncome !== 0) {
    const custodialProportion = Math.round((custodialAdjustedIncome / combinedAdjustedIncome) * 10000) / 10000;
    const nonCustodialProportion = Math.round((nonCustodialAdjustedIncome / combinedAdjustedIncome) * 10000) / 10000;
    custodialShare = custodialProportion * totalBCSO;
    nonCustodialShare = nonCustodialProportion * totalBCSO;
  }
  
  return {
    totalBCSO,
    custodialShare: Math.round(custodialShare * 100) / 100,
    nonCustodialShare: Math.round(nonCustodialShare * 100) / 100
  };
};